import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonHeader } from '@ionic/react';

import { BookedRoomDetailsModal } from './Modal_DetailData_BookedRoom';
import { BookedRoomDetailsModal_multiple } from './Modal_DetailData_BookedRoom_multiple';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { format, compareAsc } from 'date-fns';

//import '../css/hotelCss.css';
//import '../../../../css/qavaApp.css';
import '../../../css/layout.css'

export function ViewReservationsModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);



    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [bookingID, setBookingID] = useState(null);
    let [showBookedRoomDetailsModal, setBookedRoomDetailsModal] = useState(false);
    let [showBookedRoomDetailsModal_multiple, setBookedRoomDetailsModal_multiple] = useState(false);

    let [viewInventoryBookedRooms, setViewInventoryBookedRooms] = useState([]);

    useEffect(() => {

        if(props.openModal == true)
        {

            /*
            let formData = new FormData();
            formData.append('Tracker', props.tracker);
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: props.tracker,
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewInventoryBookedRooms((prevOccupiedRooms) => {
                        return prevOccupiedRooms.concat({
                            roomGuestRoomID: cols[0],
                            roomGuestFirstName: cols[1],
                            roomGuestLastName: cols[2],
                            roomGuestPhoneNumber: cols[3],
                            roomGuestPrice: parseFloat(cols[4]).toFixed(2),
                            //roomGuestCheckInDateBooked: cols[5],
                            //roomGuestCheckOutDateBooked: cols[6],
                            roomGuestCheckInDateBooked: format(new Date(cols[5]), 'E') + ", " + format(new Date(cols[5]), 'MM/dd'),
                            roomGuestCheckOutDateBooked: format(new Date(cols[6]), 'E') + ", " + format(new Date(cols[6]), 'MM/dd'),
                            roomGuestMerchantInvoiceID: cols[7],
                            roomGuestTotalOriginalAmt: parseFloat(cols[8]).toFixed(2),
                            roomGuestAmountRemaining: parseFloat(cols[9]).toFixed(2),
                            roomGuestInvoiceAttachment: cols[10],
                            bookingID: cols[11],
                            room_id_multiple: cols[12],
                            roomID: cols[13],
                            roomType: cols[14],
                            roomDescription: cols[15],
                            roomPartNum: cols[16],
                            roomPhoneNumber: cols[17],
                            address: cols[18],
                            city: cols[19],
                            country: cols[20],
                            roomSalePrice: cols[21],
                            attachment: cols[22],
                        })
                    });

                } 

            })
        }
    }, [props.openModal]);

    function bookingDetailsHandler(event)
    {
        //alert('In Booking Details Handler');
        //alert(event[1]);
        //alert(event[2]);
        //alert(event[3]);
        //alert(event[0]);

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setBookingID(event[3]);
        setBookedRoomDetailsModal(event[0]);
    }

    function bookingDetailsHandler_multiple(event)
    {
        //alert('In Booking Details Handler');
        //alert(event[1]);
        //alert(event[2]);
        //alert(event[3]);
        //alert(event[0]);

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setBookingID(event[3]);
        setBookedRoomDetailsModal_multiple(event[0]);
    }

    function closeModalHandler() {

        setViewInventoryBookedRooms([]);
        setBookedRoomDetailsModal(false);
        props.closeModal(false);
    }

    const getAmtClass = (total, remaining) => {
        const t = parseFloat(total ?? 0);
        const r = parseFloat(remaining ?? 0);
        const EPS = 0.000001;
      
        if (Math.abs(r) < EPS && Math.abs(t) > EPS) return "paid";          // green
        if (Math.abs(t - r) < EPS) return "unpaid";    // red (no payment yet)
        return "partial";                               // yellow (some balance left)
      };


    function closeModalHandler_multiple() {

        setViewInventoryBookedRooms([]);
        setBookedRoomDetailsModal_multiple(false);
        props.closeModal(false);
    }

    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal id='showBookedRooms' isOpen={ props.openModal }>


            <IonHeader style={{color: 'black'}}>
                <IonText> Rooms Booked/Reserved </IonText>
            </IonHeader>

            <IonContent className='grid_content'>
                <IonGrid >
                    <IonRow >
                            <IonCol size='1' >ID</IonCol>
                            {/*<IonCol >Room Type</IonCol>*/}
                            {/*<IonCol >Room Phone Number</IonCol>*/}
                            <IonCol size='3' >Name</IonCol>
                            <IonCol size='3' >Total/Balance</IonCol>
                            <IonCol size='3' >Check-In</IonCol> 
                            {/*<IonCol size='3' >Check-Out</IonCol>*/}                                                                               
                            <IonCol size='2' >Action</IonCol>
                    </IonRow>
                    {viewInventoryBookedRooms.map((detailData) =>   {

                        const amtClass = getAmtClass(detailData.roomGuestTotalOriginalAmt, detailData.roomGuestAmountRemaining);

                        return (
                            <IonRow >
                                <IonCol size='1' >{detailData.roomID}</IonCol>
                                {/*<IonCol >{detailData.roomType}</IonCol>*/}
                                {/*<IonCol >{detailData.roomGuestPhoneNumber}</IonCol>*/}
                                <IonCol size='3' >{detailData.roomGuestFirstName +" "+ detailData.roomGuestLastName}</IonCol>
                                <IonCol size='3' className={`amountCol ${amtClass}`}>{detailData.roomGuestTotalOriginalAmt +" / "+ detailData.roomGuestAmountRemaining}</IonCol>
                                <IonCol size='3' >{detailData.roomGuestCheckInDateBooked}</IonCol>
                                {/*<IonCol size='3' >{detailData.roomGuestCheckOutDateBooked}</IonCol>*/}
                                <IonCol size='2' >
                                    {/*<IonButton  onClick={() => this.updateViewAttachmentModal([true, detailData.roomGuestInvoiceAttachment, detailData.roomID, detailData.roomSalePrice])}> View Invoice </IonButton>                                      
                                    <IonButton  onClick={() => this.updateBookedRoomDetailsModal([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestPhoneNumber])}> Details </IonButton>*/}  
                                    {detailData.room_id_multiple == 'NO' && <IonButton  onClick={() => bookingDetailsHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.bookingID])}> Details </IonButton>}
                                    {detailData.room_id_multiple != 'NO' && <IonButton  onClick={() => bookingDetailsHandler_multiple([true, detailData.roomID, detailData.roomSalePrice, detailData.bookingID])}> M_Details </IonButton>}
                                </IonCol>
                            </IonRow>
                        )
                    }
                    )}
                </IonGrid>

            </IonContent>

            {showBookedRoomDetailsModal == true && <BookedRoomDetailsModal openModal={ showBookedRoomDetailsModal } closeModal={() => closeModalHandler()} data={{
                                    roomID: roomID, 
                                    roomSalePrice: roomSalePrice,
                                    bookingID: bookingID,
                }}></BookedRoomDetailsModal>}
            
            {showBookedRoomDetailsModal_multiple == true && <BookedRoomDetailsModal_multiple openModal={ showBookedRoomDetailsModal_multiple } closeModal={() => closeModalHandler_multiple()} data={{
                                    roomID: roomID, 
                                    roomSalePrice: roomSalePrice,
                                    bookingID: bookingID,
                }}></BookedRoomDetailsModal_multiple>}

                <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>
            </IonModal>) : null }
        </React.Fragment>
    )
}